export function getRuntimeConfig() {
  return ((window as any).__SURVEYSAAS_CONFIG__ || {}) as Record<string, string>
}

export function getRuntimeApiBaseUrl(fallback: string) {
  return getRuntimeConfig().VITE_APP_API_BASEURL || fallback
}
